













import Vue from 'vue';

export default Vue.extend({
  name: 'AddButton',
  data: () => ({}),
  methods: {
    handleClick() {
      setTimeout(() => {
        this.$emit('click');
      }, 500);
    },
  },
});
